/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminClimateEntrySTokenMultiplierPatch$Params {
  sToken: string;
  multiplier: number;
}

export function adminClimateEntrySTokenMultiplierPatch(http: HttpClient, rootUrl: string, params: AdminClimateEntrySTokenMultiplierPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, adminClimateEntrySTokenMultiplierPatch.PATH, 'patch');
  if (params) {
    rb.path('sToken', params.sToken, {});
    rb.path('multiplier', params.multiplier, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

adminClimateEntrySTokenMultiplierPatch.PATH = '/admin/climateEntry/{sToken}/{multiplier}';
